import { en } from './en';
import { pt } from './pt';

export const messages = { en, pt };
